import { render, staticRenderFns } from "./PriceSettings.vue?vue&type=template&id=2b16cb6e&scoped=true&"
import script from "./PriceSettings.vue?vue&type=script&lang=js&"
export * from "./PriceSettings.vue?vue&type=script&lang=js&"
import style0 from "./PriceSettings.vue?vue&type=style&index=0&id=2b16cb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16cb6e",
  null
  
)

export default component.exports